import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';
import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// TYPES

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { getBetState, getButtonState, getDeviceInfo, getGlobalStyles, getUIState, setPopupPanel } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// BUTTONS
import { TPopupPanel } from '@Managers/Redux/AppState/AppState.types';
import { BetButton } from '@UILayer/Buttons';

import { DOM_ID } from '@UILayer/UILayer.types';

const BetInfo: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { active: boolean; value: number }, newState: any) => ({ ...state, ...newState }), {
        active: false,
        value: 0
    });

    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const device = useAppSelector(getDeviceInfo);
    const gameStoreButtonState = useAppSelector(getButtonState);
    const gameStoreBetState = useAppSelector(getBetState);
    const globalStyles = useAppSelector(getGlobalStyles);
    const uiState = useAppSelector(getUIState);

    const infoCN = cn(
        styles.infoGroup,
        styles.betInfo_container,
        globalStyles.screenSize,
        globalStyles.orientation,
        globalStyles.device,
        globalStyles.wcaMode,
        globalStyles.isTablet
    );

    useEffect(() => {
        let active = gameStoreButtonState.isBetDecreaseButtonActive || gameStoreButtonState.isBetIncreaseButtonActive;

        if (uiState.uiFreeze) active = false;

        setState({
            active: active,
            value: gameStoreBetState.value.formatted
        });
    }, [gameStoreBetState, gameStoreButtonState, uiState]);

    useEffect(() => {}, [globalStyles]);

    function buttonAction() {
        if (state.active) {
            dispatch(setPopupPanel(TPopupPanel.bet));
        }
    }

    return (
        <>
            <div className={infoCN}>
                <div className={cn(styles.button_item, styles.betOption)}>
                    <BetButton type="minus" />
                </div>
                <div
                    className={styles.text_item}
                    onPointerDown={(e) => buttonAction()}
                    onKeyDown={(e) => KeyboardEventCheck(e as any, buttonAction)}
                    role="button"
                    tabIndex={0}
                    aria-haspopup="dialog"
                    aria-valuetext={JSON.stringify(state.value)}
                    aria-labelledby="currentBetValue"
                    aria-live="polite"
                    aria-description={t('WCA_OPEN_BET_PANEL')}
                >
                    {device.windowOrientationHorizontal && (
                        <div
                            className={styles.group_label}
                            id={DOM_ID.BET_LABEL}
                            style={{ fontSize: `${globalStyles.balanceFontSize - globalStyles.balanceFontSize / 4}px` }}
                        >
                            {t('BET')}
                        </div>
                    )}
                    <div className={cn(styles.group_value)} style={{ fontSize: `${globalStyles.balanceFontSize}px` }}>
                        {state.value}
                    </div>
                </div>
                <div className={cn(styles.button_item, styles.betOption)}>
                    <BetButton type="plus" />
                </div>

                {device.windowOrientationPortrait && (
                    <div className={styles.group_label} id={DOM_ID.BET_LABEL}>
                        {t('BET')}
                    </div>
                )}
            </div>
        </>
    );
};

export default BetInfo;
